import { useState, useEffect } from 'react';
import { db } from '@/lib/firebase';
import { doc, onSnapshot } from 'firebase/firestore';

export function useLandingImages() {
  const [images, setImages] = useState({
    heroImage: 'https://static.readdy.ai/image/3aca7b4f25b4386bcee0afd7be9c4116/f77e28a92349fc21878c3f9934539e9c.png',
    aboutImage: 'https://static.readdy.ai/image/3aca7b4f25b4386bcee0afd7be9c4116/1b36d260374789fe51e8e9cc75190d21.png',
  });

  useEffect(() => {
    const unsub = onSnapshot(doc(db, 'settings', 'landing_images'), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setImages(prev => ({
          heroImage: data.heroImage || prev.heroImage,
          aboutImage: data.aboutImage || prev.aboutImage,
        }));
      }
    });

    return () => unsub();
  }, []);

  return images;
}
